// extracted by mini-css-extract-plugin
export default {"last-price-container":"lastPrice_last-price-container__V38t5","up":"lastPrice_up__ieUoi","down":"lastPrice_down__Ky0LP"};